{
  "jsm-gs.cases.spotlight.step1.body.non-final": [
    {
      "type": 0,
      "value": "Streamline how your team documents findings and outcomes with a dedicated "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Case notes"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " section within work items."
    }
  ],
  "jsm-gs.cases.spotlight.step1.next.non-final": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jsm-gs.cases.spotlight.step1.step-count.non-final": [
    {
      "type": 0,
      "value": "1 of 3"
    }
  ],
  "jsm-gs.cases.spotlight.step1.title.non-final": [
    {
      "type": 0,
      "value": "Better manage your case load"
    }
  ],
  "jsm-gs.cases.spotlight.step2.back.non-final": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "jsm-gs.cases.spotlight.step2.body.non-final": [
    {
      "type": 0,
      "value": "To enable "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Case notes"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " on work items, simply create or assign existing request types to this work category."
    }
  ],
  "jsm-gs.cases.spotlight.step2.next.non-final": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jsm-gs.cases.spotlight.step2.step-count.non-final": [
    {
      "type": 0,
      "value": "2 of 3"
    }
  ],
  "jsm-gs.cases.spotlight.step2.title.non-final": [
    {
      "type": 0,
      "value": "Create or assign existing types"
    }
  ],
  "jsm-gs.cases.spotlight.step3.back.non-final": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "jsm-gs.cases.spotlight.step3.body.non-final": [
    {
      "type": 0,
      "value": "Lock down sensitive "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Cases"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " with work item security so only those with access can view case information."
    }
  ],
  "jsm-gs.cases.spotlight.step3.done.non-final": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "jsm-gs.cases.spotlight.step3.step-count.non-final": [
    {
      "type": 0,
      "value": "3 of 3"
    }
  ],
  "jsm-gs.cases.spotlight.step3.title.non-final": [
    {
      "type": 0,
      "value": "Restrict access to specific people"
    }
  ]
}